/**
 * i18n setup — Task 31.3
 * react-i18next with JSON locale files, RTL support.
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'

const SUPPORTED_LOCALES = (
  import.meta.env.VITE_SUPPORTED_LOCALES ?? 'en-US,fr-FR,ar-SA,es-ES'
).split(',')

const DEFAULT_LOCALE = import.meta.env.VITE_DEFAULT_LOCALE ?? 'en-US'

const I18N_NAMESPACES = (
  import.meta.env.VITE_I18N_NAMESPACES ?? 'common,auth,catalog,cart,checkout,account,admin'
).split(',')

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES,
    ns: I18N_NAMESPACES,
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
  })

export default i18n

/** RTL locales */
export const RTL_LOCALES = ['ar-SA', 'ar', 'he', 'fa', 'ur']

export function isRTL(locale: string): boolean {
  return RTL_LOCALES.some((rtl) => locale.startsWith(rtl))
}

export { SUPPORTED_LOCALES, DEFAULT_LOCALE }
